// Phase 2D.2 checkpoint 2B — where to return AFTER signing in.
//
// WHAT IT STORES
//   A PATH, from a fixed allow-list, and nothing else. Never a token, never a
//   query string, never a fragment, never an absolute URL, never an origin.
//
// WHY AN ALLOW-LIST
//   A "return to" value read back from storage and handed to the router is an
//   open-redirect primitive the moment it can be anything. Three exact paths are
//   accepted; everything else is discarded silently.
//
// WHY THE TOKEN IS NOT HERE
//   An invitation token stays in MEMORY (see lib/inviteToken.js) for its whole
//   life. Navigating to /login and back is a client-side route change inside the
//   same document, so the module variable survives it and the token never needs
//   to be persisted, serialised or put back into a URL.

const KEY = "offertrace.auth_continuation";

const ALLOWED = Object.freeze([
  "/auth/accept-invite",
  "/auth/accept-invitation",
  "/auth/accept-owner-invite",
]);

function store() {
  try {
    return typeof window === "undefined" ? null : window.sessionStorage;
  } catch (err) {
    return null;
  }
}

/** Remember a continuation path. A value outside the allow-list is ignored. */
export function rememberContinuation(path) {
  if (!ALLOWED.includes(path)) return;
  const s = store();
  if (!s) return;
  try {
    s.setItem(KEY, path);
  } catch (err) {
    // Storage unavailable (private mode). The person simply lands on the
    // dashboard and can follow the invitation link again.
  }
}

/** Read AND remove the continuation. Returns null when there is nothing safe. */
export function takeContinuation() {
  const s = store();
  if (!s) return null;
  let value = null;
  try {
    value = s.getItem(KEY);
    s.removeItem(KEY);
  } catch (err) {
    return null;
  }
  return ALLOWED.includes(value) ? value : null;
}

export function clearContinuation() {
  const s = store();
  if (!s) return;
  try {
    s.removeItem(KEY);
  } catch (err) {
    // Nothing to do: the value is a path, not a secret.
  }
}

export const CONTINUATION_KEY = KEY;
export const CONTINUATION_ALLOWED = ALLOWED;
